import React from 'react';
import './ERPSystem.css';

const erpIndustries = [
    {
        title: 'Manufacturing',
        icon: '🏭',
        details: [
            'Production Planning & Scheduling',
            'Inventory & Warehouse Automation',
            'Quality Control & Compliance',
            'Multi-Plant Management',
        ],
    },
    {
        title: 'Retail & eCommerce',
        icon: '🏬',
        details: [
            'Point of Sale (POS) Integration',
            'Real-Time Inventory Tracking',
            'Customer Order Management',
            'Omnichannel Sales Monitoring',
        ],
    },
    {
        title: 'Healthcare',
        icon: '🏥',
        details: [
            'Patient Billing & Finance Modules',
            'Pharmacy & Stock Management',
            'HR & Shift Management',
            'Compliance & Audit Reporting',
        ],
    },
    {
        title: 'Construction',
        icon: '🛠️',
        details: [
            'Project Costing & Budgeting',
            'Contractor Management',
            'Material Procurement Tracking',
            'Timekeeping & Payroll',
        ],
    },
    {
        title: 'Education',
        icon: '🎓',
        details: [
            'Fee & Financial Modules',
            'HR & Staff Payroll',
            'Student Information System Integration',
            'Hostel & Resource Management',
        ],
    },
    {
        title: 'Logistics & Supply Chain',
        icon: '🚚',
        details: [
            'Fleet & Route Optimization',
            'Dispatch & Inventory Control',
            'Supplier & Vendor Coordination',
            'Real-Time Shipment Tracking',
        ],
    },
];

const features = [
    'Real-Time Data Synchronization',
    'Multi-Module Integration (HR, Finance, Inventory, CRM)',
    'Advanced Reporting & BI Dashboards',
    'Cloud, On-Premise & Hybrid Deployment Options',
    'Multi-User & Role-Based Access Control',
    'API Integration with External Platforms',
    'Highly Scalable & Modular Architecture',
    'Customizable Workflows & Business Rules'
];


const benefits = [
    'Process Automation across Departments',
    'Enhanced Visibility & Centralized Data',
    'Reduced Operational Costs & Time',
    'Improved Collaboration & Workflow Efficiency',
    'Better Decision Making with Real-Time Reports',
    'Scalability to Support Business Growth',
    'Regulatory Compliance & Data Accuracy',
    'Improved Customer Satisfaction through Faster Service'
];


const ERPSystem = () => {
    return (
        <div className="erp-container">
            <h1 className="erp-title">ERP System Development</h1>
            <p className="erp-subtitle">
                Our custom ERP solutions streamline business operations, improve accuracy, and provide real-time visibility
                across your enterprise — all within a unified digital platform.
            </p>

            <section className="erp-section">
                <h2 className="section-heading">Industries We Serve</h2>
                <div className="industry-grid">
                    {erpIndustries.map(({ title, icon, details }) => (
                        <div key={title} className="industry-card gradient-border-card">
                            <h3 className="industry-title">{icon} {title}</h3>
                            <ul className="industry-list">
                                {details.map((item, idx) => (
                                    <li key={idx}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </section>
            <section className="erp-section">
                <h2 className="section-heading">Key Features of Our ERP Systems</h2>
                <div className="erp-card-grid">
                    {features.map((feature, idx) => (
                        <div key={idx} className="erp-card bottom-border-card">
                            <div className="erp-icon">✔️</div>
                            <div className="erp-text">{feature}</div>
                        </div>
                    ))}
                </div>
            </section>

            <section className="erp-section">
                <h2 className="section-heading">Benefits of Implementing ERP</h2>
                <div className="erp-card-grid">
                    {benefits.map((benefit, idx) => (
                        <div key={idx} className="erp-card bottom-border-card">
                            <div className="erp-icon">🚀</div>
                            <div className="erp-text">{benefit}</div>
                        </div>
                    ))}
                </div>
            </section>




            <section className="erp-cta">
                <h3>Transform the Way Your Business Operates</h3>
                <p>Let’s develop a scalable ERP platform that fits your exact business needs and grows with you.</p>
                <a href="https://wa.me/919316580274" target="_blank" rel="noopener noreferrer">
                    <button className="erp-button">Request a Free ERP Demo</button>
                </a>
               
            </section>
        </div>
    );
};

export default ERPSystem;
